import { Tooltip } from "antd";
import React, { useContext, useEffect, useState, useCallback } from "react";
import { IoCheckmarkDoneOutline } from "react-icons/io5";
import uuid from "react-uuid";
import FetchContext from "../../../../contexts/fetch";
import FlowContext from "../../../../contexts/flowContext";
import NotificationContext from "../../../../contexts/notification";
import UserContext from "../../../../contexts/user";
import useConfirmation from "../../../../hooks/useConfirmation";
import Spinner from "../../../Spinner";
import styles from "../controls.module.css";
import { flowToConfig } from "../utils";

const Publish = () => {
  const [flowState] = useContext(FlowContext);
  const [fetchState, fetchDispatcher] = useContext(FetchContext);
  const [userState] = useContext(UserContext);
  const [, notificationDispatcher] = useContext(NotificationContext);

  const [shouldRender, setShouldRender] = useState(false);
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setShouldRender(flowState._id !== null && flowState._id !== undefined);
  }, [flowState._id]);

  useEffect(() => {
    if (config) {
      saveWithConfirmation();
    }
  }, [config]);

  const onPublish = function () {
    fetchDispatcher({
      type: "fetch-publish-flow",
      brand: userState.currentBrand,
      flowName: flowState.name,
      flowId: flowState._id,
      version: flowState.version,
      config,
      onSuccess: (msg) => {
        notificationDispatcher({
          type: "notify",
          notification: {
            id: uuid(),
            type: "success",
            message: msg,
            duration: 3000,
          },
        });
        fetchDispatcher({
          type: "fetch-flow-list",
          app: userState.currentApp,
        });
      },
      onError: (msg) => {
        notificationDispatcher({
          type: "notify",
          notification: {
            id: uuid(),
            type: "failure",
            message: msg,
            duration: 3000,
          },
        });
      },
    });
  };

  const saveWithConfirmation = useConfirmation(
    {
      title: "Confirmer la publication",
      message:
        "La publication des configs écrasera l'ancienne version. Continuer ?",
      onOk: onPublish,
    },
    fetchState.loadingPublishFlowApi
  );

  const handlePublishButtonClick = async function (e) {
    setLoading(true);
  };

  useEffect(() => {
    if (loading) {
      setTimeout(() => {
        setConfig(
          flowToConfig(
            flowState,
            userState.currentApp,
            fetchState.clientConfig.edge
          )
        );
        setLoading(false);
      }, 50);
    }
  }, [loading]);

  return (
    shouldRender && (
      <div
        className={styles.button_container}
        onClick={handlePublishButtonClick}
      >
        <Spinner spinning={loading} style={{ paddingBottom: "10px" }} />
        {!loading && (
          <Tooltip placement="bottom" title={"Publish"}>
            <span className={styles.icon_container}>
              <IoCheckmarkDoneOutline className={styles.publish_button} />
            </span>
          </Tooltip>
        )}
      </div>
    )
  );
};

export default Publish;
